import { render } from "./ScreenSaver.vue?vue&type=template&id=897d25c8&scoped=true"
import script from "./ScreenSaver.vue?vue&type=script&lang=js"
export * from "./ScreenSaver.vue?vue&type=script&lang=js"

import "./ScreenSaver.vue?vue&type=style&index=0&id=897d25c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897d25c8"]])

export default __exports__